import { todayString } from 'utils/date'
import { ACTIVITY_TYPE_INPUT } from 'constants/stock-activity'

export const EMPTY_STOCK_ACTIVITY = {
  attributes: {
    date: '',
    description: '',
    activity_type: '',
    quantity: '',
    product_id: '',
  },
}

export const INITIAL_STOCK_ACTIVITY = {
  attributes: {
    ...EMPTY_STOCK_ACTIVITY.attributes,
    date: todayString(),
    activity_type: ACTIVITY_TYPE_INPUT,
  },
}
